import { useRouteLoaderData } from 'react-router-dom';
import type { LeadCollection } from '@/models/ui/LeadCollection.ts';

export function useLeadCollection(): LeadCollection {
  const data = useRouteLoaderData<LeadCollection>('leads');

  if (!data) {
    throw new Error('LeadCollection is not available');
  }

  return data;
}
